import styled from 'styled-components';
import { rem } from 'polished';

const ListItem = styled.button.attrs({
  href: '#',
  type: 'button',
})`
  display: block;
  width: 100%;
  text-align: center;
  margin: 0;
  padding: 1rem;
  border: none;
  border-bottom: 1px solid ${(props) => props.theme.palette.border};
  font-weight: 700;
  font-size: ${rem('14px')};
  color: ${(props) => props.theme.palette.text};
  cursor: pointer;

  &:hover {
    color: ${(props) => props.theme.palette.primary[0]};
  }
`;

export default ListItem;
